import React, { useEffect, useState } from 'react';
import { isTelegramMiniApp, initTelegramWebApp } from '../../utils/telegramUtils';

const TelegramGuard = ({ children }) => {
  const [isValidEnvironment, setIsValidEnvironment] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Poll for Telegram object (up to 3 seconds)
    let attempts = 0;
    const maxAttempts = 30; // 30 * 100ms = 3s

    const checkTelegram = () => {
      // Bypass in development mode
      if (process.env.NODE_ENV === 'development') {
        console.log('Telegram Guard bypassed in development mode');
        setIsValidEnvironment(true);
        setIsChecking(false);
        return;
      }

      // Strict check: Only allow if initData is present (proof of running in TG)
      if (isTelegramMiniApp()) {
        setIsValidEnvironment(true);
        initTelegramWebApp();
        setIsChecking(false);
        return;
      }

      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(checkTelegram, 100);
      } else {
        // Final check failed & timed out
        console.warn('Telegram WebApp not detected after timeout.');
        setIsChecking(false);
      }
    };

    checkTelegram();
  }, []);

  if (isChecking) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isValidEnvironment) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6 text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Access Denied</h1>
        <p className="text-gray-600 max-w-xs">
          This application is only accessible through the Telegram Mini App.
        </p>
      </div>
    );
  }

  return children;
};

export default TelegramGuard;